import { tf } from '@/i18n'

export default {
  required: v => !!v || tf('rules.fieldRequired'),
  /* eslint-disable max-len */
  email: v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || tf('rules.emailRequired'),
  length20: v => !!v && v.length === 20 || tf('rules.20lengthRequired'),
  length18: v => !!v && v.length === 18 || tf('rules.18lengthRequired'),
  length16: v => !!v && v.length === 16 || tf('rules.16lengthRequired'),
  length12: v => !!v && v.length === 12 || tf('rules.12lengthRequired'),
  length10: v => !!v && v.length === 10 || tf('rules.10lengthRequired'),
  length9: v => !!v && v.length === 9 || tf('rules.9lengthRequired'),
  validAndMax50000: v => !!v && !isNaN(v) && Number(v) <= 50000 || tf('rules.valueIsNotCorrectOrShouldNotExeed50000'),
  validAndMax100000: v => !!v && !isNaN(v) && Number(v) <= 100000 || tf('rules.valueIsNotCorrectOrShouldNotExeed100000'),
  validAndMax150000: v => !!v && !isNaN(v) && Number(v) <= 150000 || tf('rules.valueIsNotCorrectOrShouldNotExeed150000'),
  validAndMax300000: v => !!v && !isNaN(v) && Number(v) <= 300000 || tf('rules.valueIsNotCorrectOrShouldNotExeed300000'),
  dateFormat: v => !!v && /^(((0[1-9]{1})|([1-2]{1}[0-9]{1})|(3[0-1]{1}))-((0[1-9]{1})|(1[0-2]{1}))-[1-2]{1}[0-9]{3})$/.test(v) || tf('rules.incorrectFormat')
}



// WEBPACK FOOTER //
// ./src/utils/validationRules.js